import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class activityService {
  async fetch(params) {
    try {
      const result = await client.get('userappactivity/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new activityService();
